module.exports = __webpack_public_path__ + "h5/img/detail-opt1.4dab5201.png";